/* global tracker */
/* eslint no-param-reassign: "warn" */
import {
  sendGoogleEvent,
  parameters,
  generateInViewportEvent,
  libInit,
  initLazyLoad,
  getServiceWorkerSupport,
  getActiveServiceWorkerFlag,
  sendRequest,
  isElementOnScreen,
  byWindowAction,
  sendDataLayerEvent,
  byUserInteraction,
  sendAmplitudeEvent,
} from '@html/_common/utils';

import SerpToursBrochure from '@html/serp/tours/brochure';
import SerpToursWishlist from '@html/serp/tours/wishlist';
import AOSerpTourTags from '@atomic/organisms/serp/tour-tags';
import SerpToursHighlightTags from '@html/serp/tours/highlight-tags';
import TourCategory from '@scout/components/tour-category/tour-category';

export default function SerpTours(serpCommon) {
  const {
    getPageType, getPageId, getUrlParam,
  } = serpCommon;

  const TABLET_WIDTH = 1023;
  const MOBILE_WIDTH = 767;
  const SELECTOR_JS_TOUR_CARD = '.js-ao-serp-tour-card';
  const SELECTOR_JS_TOUR_NAME = '.js-ao-serp-tour__name';
  const SELECTOR_TOOLTIP = '.js-ao-serp-tour__name-tooltip';
  const SELECTOR_JS_TOUR_LINK = '.js-tour-link';
  const CLASS_WISHLIST_BUTTON = 'js-ao-serp-tour-card__hero-button--wishlist';
  const CLASS_WISHLIST_ACTIVE_CLASS = 'ao-serp-tour-card__hero-button--wishlist-active';
  const SELECTOR_JS_RATING_LINK = '.js-ao-serp-tour-card__reviews';
  const SELECTOR_BROCHURE_DOWNLOAD_BUTTON = '.js-ao-serp-tour-card__button--brochure-download';
  const SELECTOR_JS_IMAGE_LINK = 'img:not(.map)';
  const SELECTOR_TOUR_TAGS_SHOW_MORE = '.js-ao-serp-tour-card__tags-show-more';
  const SELECTOR_TOUR_CATEGORY_TOOLTIP_CONTAINER = '.js-ao-serp-tour-card__tags-container';
  const CLASS_JS_TOUR_VIEWED = 'tour-viewed';
  const NUMBER_OF_TOURS_PER_PAGE = parseInt($('main').attr('data-onpage'), 10);
  const SELECTOR_JS_OPERATOR_CARD = 'li.oper';
  const SELECTOR_SLIDER_POPUP_CLOSE = '.js-scout-slider-popup__close';
  const SELECTOR_SLIDER_POPUP = '.ao-serp-tour-card__installments__slider-popup';
  const SELECTOR_SLIDER = '.ao-serp-tour-card__installments__slider';
  const SELECTOR_TOOLTIP_ICON = '.ao-serp-tour-card__installments';

  const serpBrochure = new SerpToursBrochure(
    SELECTOR_BROCHURE_DOWNLOAD_BUTTON,
    SELECTOR_JS_TOUR_CARD,
    SELECTOR_JS_TOUR_NAME,
  );
  const wishlist = new SerpToursWishlist(
    SELECTOR_JS_TOUR_CARD,
    CLASS_WISHLIST_BUTTON,
    CLASS_WISHLIST_ACTIVE_CLASS,
  );
  const serpTourTags = new AOSerpTourTags();
  const highlightTags = new SerpToursHighlightTags();
  const PAGINATION = '.scout-pagination';
  const $PAGINATION_ELEMENT = $('body').find(PAGINATION);
  const LOAD_MORE = '.js-serp-list-load-more';
  let parametersList = {};
  let tooltips;
  let isEmptyResultTemplateLoaded = false;
  let lastOmTimeOut;
  let contentElement;
  let currentParams;
  let serpMap;
  let serpCache;
  let communityBannerHtml;

  this.currentPage = parameters.page || 1;
  this.locationHistory = [];

  /* Create DOM observer for empty results */
  const viewportListener = generateInViewportEvent({
    category: 'SERP',
    action: 'Scroll',
    label: 'No result - CTA',
    params: { ampEventName: 'serp_noresult_cta_shown' },
  });

  const updateTourResultsHeading = () => {
    const hash = window.location.hash.substring(1); // Remove the # symbol
    const fragments = hash.split(',');

    let adults = 0;
    let children = 0;

    // Extract adults and children from fragments
    fragments.forEach((fragment) => {
      const [key, value] = fragment.split('=');
      if (key === 'adults') {
        adults = parseInt(value, 10) || 0;
      } else if (key === 'children') {
        children = parseInt(value, 10) || 0;
      }
    });

    // Hide all spans first
    $('.js-am-serp-results-stats__title-for').addClass('hid');

    // Show the appropriate span based on adults and children count
    if (adults === 1 && children === 0) {
      // 1 Adult
      $('.js-am-serp-results-stats__title-for-adult').removeClass('hid');
    } else if (adults === 1 && children === 1) {
      // 1 Adult and 1 Child
      $('.js-am-serp-results-stats__title-for-adult-child').removeClass('hid');
    } else if (adults === 1 && children > 1) {
      // 1 Adult and X Children
      $('.js-am-serp-results-stats__title-for-adult-children').removeClass('hid');
      $('.js-am-serp-results-stats__title-for-adult-children').text($('.js-am-serp-results-stats__title-for-adult-children').text().replace('{{children}}', children));
    } else if (adults > 1 && children === 1) {
      // X Adults and 1 Child
      $('.js-am-serp-results-stats__title-for-adults-child').removeClass('hid');
      $('.js-am-serp-results-stats__title-for-adults-child').text($('.js-am-serp-results-stats__title-for-adults-child').text().replace('{{adults}}', adults));
    } else if (adults > 1 && children > 1) {
      // X Adults and Y Children
      $('.js-am-serp-results-stats__title-for-adults-children').removeClass('hid');
      $('.js-am-serp-results-stats__title-for-adults-children').text($('.js-am-serp-results-stats__title-for-adults-children').text().replace('{{adults}}', adults).replace('{{children}}', children));
    } else if (adults > 1 && children === 0) {
      // X Adults and 0 Children
      $('.js-am-serp-results-stats__title-for-adults').removeClass('hid');
      $('.js-am-serp-results-stats__title-for-adults').text($('.js-am-serp-results-stats__title-for-adults').text().replace('{{adults}}', adults));
    }
  };

  const updateTourQuantity = ($element, data) => {
    if ($element.length > 0) {
      if ($('.js-am-serp-results-stats__results-text').length > 0) {
        if (data.count === 1) {
          $('.js-am-serp-results-stats__results-text').addClass('hid');
          $('.js-am-serp-results-stats__result-text').removeClass('hid');
          $('.js-am-serp-results-stats__result-text-count').text(data.count);
        } else {
          $('.js-am-serp-results-stats__result-text').addClass('hid');
          $('.js-am-serp-results-stats__results-text').removeClass('hid');
          $('.js-am-serp-results-stats__results-text-count').text(data.count > 250 ? '250+' : data.count);
        }
        if ($('.ao-header-pax-selector').length) {
          updateTourResultsHeading();
        }
      } else if (data.h2_text !== null) {
        $element.html(data.h2_text);
      } else {
        $element.first().find('.js-am-serp-results-stats__count').text(data.count > 250 ? '250+' : data.count);
        $element.first().find('.js-am-serp-results-stats__page').remove();
      }
    }
  };

  const trackingTourPosition = (event) => {
    const $element = $(event.currentTarget);
    const $tourBlock = $element.closest(SELECTOR_JS_TOUR_CARD);
    const tourId = $tourBlock?.data('id');
    const urlParams = new URLSearchParams(window.location.search);
    const pageStr = urlParams.get('page');
    const page = pageStr ? parseInt(pageStr, 10) : 1;

    if ($tourBlock.length > 0) {
      $(SELECTOR_JS_TOUR_CARD).each((index, block) => {
        if ($(block).data('id') === tourId) {
          const tourPosition = (page - 1) * NUMBER_OF_TOURS_PER_PAGE + (index + 1);
          localStorage.setItem('tourPosition', JSON.stringify(tourPosition));
        }
      });
    }
  };

  const regenerateLinks = () => {
    $('.list ul li .js-tour-link').off('click.filter').on('click.filter', (event) => {
      const $element = $(event.currentTarget);
      const addToHash = [];

      if (parametersList.month) {
        addToHash.push(`months=${parametersList.month}`);
      }

      if (addToHash.length > 0) {
        let url = $element.attr('href').replace(/#.*/, '');

        addToHash.forEach((value, index) => {
          url += (index > 0 ? ',' : '#') + value;
        });

        $element.attr('href', url);
      }

      trackingTourPosition(event);
    });
  };

  const tooltipDeparture = () => {
    if (getPageType() === 'g') {
      return;
    }

    if (tooltips) {
      $('div.inst').attr('title', '').data('text', `<div><b>Instant Booking</b></div>${tooltips.inst}`).addClass('ttip');

      libInit('tooltip');
    }
  };

  const initiateTooltips = () => {
    if (getPageType() === 'g') {
      return;
    }

    $(document).off('scroll', initiateTooltips);

    $('.list ul').off('mouseenter', SELECTOR_JS_TOUR_CARD, initiateTooltips);
    TourCategory({ containerSelector: SELECTOR_TOUR_CATEGORY_TOOLTIP_CONTAINER });

    if (tooltips) {
      tooltipDeparture();
    } else {
      sendRequest('/api/tour/load', {
        action: 'ttip_text',
      }, (data) => {
        if (data && data.status === 'OK') {
          tooltips = data.texts;

          tooltipDeparture();
        }
      });
    }
  };

  const showEmptyResults = ($toursCountInfoElement) => {
    $('.list ul:not(.js-empty__actions)').addClass('hid');
    if ($PAGINATION_ELEMENT.hasClass('hid')) {
      $('body').find(LOAD_MORE).addClass('hid');
    }
    $('.list .empty').removeClass('hid');

    $('.list .js-ao-serp-tour-card').removeClass('pending');
    $toursCountInfoElement.closest('.js-am-serp-results-stats').addClass('hid');

    const noResultCta = document.querySelector('.js-empty__cta');
    if (noResultCta) {
      viewportListener.observe(noResultCta);
    }
  };

  const tooltipOperatorRating = () => {
    if (getPageType() === 'g') {
      return;
    }

    if ($('.list .tc:not(.ttip)').length) {
      $('.list .tc:not(.ttip)').each((index, element) => {
        const $element = $(element);
        $element.addClass('ttip');
      });

      libInit('tooltip');
    }
  };

  const storeCommunityBanner = () => {
    const $communityBanner = $('.js-ao-community-banner');
    if ($communityBanner.length > 0) {
      communityBannerHtml = $communityBanner.prop('outerHTML');
      $communityBanner.remove();
    }
  };

  const applyCommunityBanner = () => {
    const $tours = $('.list > ul > li');
    if (communityBannerHtml && $tours.length > 3) {
      $tours.eq(2).after(communityBannerHtml);
      initLazyLoad();
    }
  };

  const sendLoadToursRequest = (pagination, customParams = {}) => {
    /* process pagination */
    if (pagination) {
      this.currentPage += 1;
    } else {
      this.currentPage = 1;
    }

    if (!lastOmTimeOut) {
      lastOmTimeOut = 0;
    }

    if (lastOmTimeOut) {
      clearTimeout(lastOmTimeOut);
    }

    const params = parametersList;

    /* get sorting */
    params.order = this.resultOrder;
    params.page = this.currentPage;
    params.type = getPageType();
    params.id = getPageId();
    params.isTours = parameters.isTours;

    if (params.adults || params.children) {
      params.pax = `${params.adults || 0}:${params.children || 0}`;
      delete params.adults;
      delete params.children;
    }

    const versionParam = getUrlParam('v');
    if (versionParam !== null) {
      params.v = versionParam;
    }

    if (currentParams === JSON.stringify(params)) {
      return;
    }

    currentParams = JSON.stringify(params);

    $('.list .js-ao-serp-tour-card').addClass('pending');

    const currentScrollTop = $(window).scrollTop();

    sendRequest(`/serp/load/${getPageId()}`, params, (data) => {
      const $toursCountInfoElement = $('.js-am-serp-results-stats__title');
      if (data && data.success) {
        data.count = parseInt(data.count, 10); //eslint-disable-line
        let timeout = 3500;
        if (customParams.order) {
          timeout = 0;
        }
        lastOmTimeOut = setTimeout(() => {
          if (window.tracker) {
            tracker('appendParameters', data.parameters || []);
          }
        }, timeout);

        if (data.count > 0) {
          if (pagination) {
            let $lastItem = $(`.list ${SELECTOR_JS_TOUR_CARD}`).last();

            if (!$lastItem.length) {
              $lastItem = $(`.list ${SELECTOR_JS_OPERATOR_CARD}`).last();
            }

            $('.list > ul').append(data.tours);
            $(window).scrollTop(currentScrollTop);
          } else {
            this.locationHistory.push(window.location.hash);

            updateTourQuantity($toursCountInfoElement, data);
            storeCommunityBanner();

            $('.list > ul').html(data.tours);

            if (communityBannerHtml && data.count > 3) {
              applyCommunityBanner();
            }

            if (contentElement && contentElement.position <= $('.list > ol > li').length) {
              $(`.list > ul > li:nth-child(${contentElement.position})`).after(contentElement.html);

              /* reinitiate lazy loading after adding travel guide block */
              initLazyLoad();
            }
          }

          $('.list ul').removeClass('hid');
          if ($('body').find(LOAD_MORE).length === 0) {
            const text = $PAGINATION_ELEMENT.data('load-more');
            $PAGINATION_ELEMENT.addClass('hid');
            $PAGINATION_ELEMENT.after(`<div class="scout-pagination__show-more-wrapper"><button class="js-serp-list-load-more scout-element__button scout-element__button--secondary scout-element__button--m scout-pagination__show-more" data-cy="search-results--load-more">${text}</button></div>`);
          }
          viewportListener.disconnect();
          $('.list > .empty').addClass('hid');
          $('.list .js-ao-serp-tour-card').removeClass('pending');

          $toursCountInfoElement.closest('.js-am-serp-results-stats').removeClass('hid');

          if ($('body').find(LOAD_MORE).length) {
            $('body').find(LOAD_MORE).removeClass('hid');
          }
          if (data.count <= this.currentPage * NUMBER_OF_TOURS_PER_PAGE) {
            if ($('body').find(LOAD_MORE).length) {
              $('body').find(LOAD_MORE).addClass('hid');
            }
          }

          regenerateLinks();

          initiateTooltips();

          const $toursStructuredData = $('.js-serp-tours-structured-data');
          if ($toursStructuredData.length && data.tours_structured_data) {
            $toursStructuredData.text(JSON.stringify(data.tours_structured_data));
          }

          if (getServiceWorkerSupport() && serpCache) {
            const clearCachePromise = serpCache.clear('tdp-images-cache-first');

            clearCachePromise.then(() => {
              const activeServiceWorkerPromise = getActiveServiceWorkerFlag();

              activeServiceWorkerPromise.then((hasActiveServiceWorker) => {
                if (hasActiveServiceWorker) {
                  serpCache.cacheTdpPagesOfCurrentSerpTourList({
                    // isCacheHtml: true,
                    shouldCacheImages: true,
                  });
                }
              });
            });
          }
        } else if (!isEmptyResultTemplateLoaded) {
          isEmptyResultTemplateLoaded = true;

          sendRequest(`/api/serp/empty-template/${getPageId()}`, {}, (emptyTemplateData) => {
            if (emptyTemplateData && emptyTemplateData.success === true) {
              $('.list').append(emptyTemplateData.component);

              showEmptyResults($toursCountInfoElement);

              if ($PAGINATION_ELEMENT.length) {
                $PAGINATION_ELEMENT.addClass('hid');
              }
            }
          });
        } else {
          showEmptyResults($toursCountInfoElement);

          if ($PAGINATION_ELEMENT.length) {
            $PAGINATION_ELEMENT.addClass('hid');
          }
        }

        tooltipOperatorRating();
        libInit('tooltip');

        const $resultsButton = $('main .see-results .but');
        if (data.count <= 0 && $('#params').hasClass('show') && this.locationHistory.length) {
          $('main .see-results').addClass('no-tours');
          $resultsButton.text($resultsButton.data('no-results'));
        } else {
          $('main .see-results').removeClass('no-tours');
          const countTours = data.count > 250 ? '250+' : data.count.toString();
          $resultsButton.text(
            data.count === 1
              ? $resultsButton.data('results-one')
              : $resultsButton.data('results-plural').replace('{{resultsCount}}', countTours),
          );
        }

        if (!pagination) {
          let results = 'more than 10 results';

          if (data.count <= 0) {
            results = 'no results';
          } else if (data.count < 5) {
            results = 'less than 5 results';
          } else if (data.count < 10) {
            results = 'less than 10 results';
          }

          const { pathname, hash } = window.location;

          sendGoogleEvent(
            'Filter results',
            results,
            pathname + hash,
            {
              nonInteraction: true,
              filterResults: data.count,
              ampEventName: 'filter_click',
              has_service_fee: data.has_service_fee,
              service_fee: data.service_fee,
            },
          );
        }
      }

      $('.see-results .but').removeClass('but--loading');

      highlightTags.trackLoad();
    });
  };

  this.updateTours = (pagination, list, resultOrder, customParameters) => {
    const filtersCount = Object.keys(list || {}).length;
    const $filtersCountBadge = $('.js-ao-serp-filter-mobile__external-badge');

    if ($filtersCountBadge.length) {
      $filtersCountBadge.toggleClass('hid', filtersCount === 0);
      $filtersCountBadge.text(filtersCount);
    }

    if (!pagination) {
      $('.see-results .but').addClass('but--loading');

      parametersList = list || {};

      this.resultOrder = resultOrder;
    }

    sendLoadToursRequest(pagination, customParameters);

    /* remove pagination from url, show "load more" button */
    if (window.location.href.indexOf('?page=') >= 0) {
      window.history.pushState('initial', document.title, window.location.href.replace(/\?page=[0-9]+/, ''));
    }

    if (!$PAGINATION_ELEMENT.hasClass('hid')) {
      if ($('body').find(LOAD_MORE).length) {
        $PAGINATION_ELEMENT.toggleClass('hid');
        $('body').find(LOAD_MORE).toggleClass('hid');
      }
    }
  };

  const checkTourViewState = (tourItems) => {
    if (!tourItems.not(`.${CLASS_JS_TOUR_VIEWED}`).length) {
      return;
    }

    tourItems.each((index, element) => {
      const $tour = $(element);
      if (!$tour.hasClass(CLASS_JS_TOUR_VIEWED) && isElementOnScreen(element)) {
        $tour.addClass(CLASS_JS_TOUR_VIEWED);

        if (window.tracker) {
          tracker('addDataSetView', 'tour', $tour.attr('data-id'), { position: index });
        }
      }
    });
  };

  const initTrackTourViews = () => {
    const tourItems = $(`.list ul ${SELECTOR_JS_TOUR_CARD}`);

    checkTourViewState(tourItems);

    byWindowAction(['scroll', 'resize'], () => {
      checkTourViewState(tourItems);
    });
  };

  const onClickEcommerceEvent = (tourId) => {
    if (!window.ecommerce || !window.ecommerce.impressions) {
      return;
    }

    for (let j = 0; j < window.ecommerce.impressions.length; j += 1) {
      const product = window.ecommerce.impressions[j];

      if (parseInt(product.id, 10) === parseInt(tourId, 10)) {
        delete product.list;
        sendDataLayerEvent({
          event: 'ecommerceEvent',
          ecommerce: {
            click: {
              actionField: {
                list: window.location.pathname + window.location.hash,
              },
              products: [product],
            },
          },
        });
        break;
      }
    }
  };

  const initiateGoogleEvents = () => {
    const $list = $('.list');

    $list.on('click', `${SELECTOR_JS_TOUR_CARD} ${SELECTOR_JS_TOUR_LINK}`, (event) => {
      const $tourElement = $(event.currentTarget).closest(SELECTOR_JS_TOUR_CARD);
      const tourId = $tourElement.data('id');
      const position = $tourElement.index() + 1;
      const count = $(`.list>ul>${SELECTOR_JS_TOUR_CARD}`).length;
      const countRecommendedTours = $('.js-ao-serp-tour--personalized').length;
      const hasExclusiveTag = $tourElement.find('.js-aa-exclusive-tag--exclusive').length;
      const hasTppPick = $tourElement.find('.js-aa-exclusive-tag--selection').length;
      const hastTagPrice = $tourElement.find('.js-aa-exclusive-tag--price').length;
      const hasFreeCancellationTag = $tourElement.find('.js-ao-serp-tour-tags__tag-free-cancellation').length;
      const hasSponsoredTag = $tourElement.data('is-sponsored') === 1;
      const hasPrice = $tourElement.find('.js-br__price-wrapper-price-description-value').length ? '1' : '0';
      const sponsoredTourID = hasSponsoredTag ? tourId.toString() : '';

      onClickEcommerceEvent(tourId);

      sendGoogleEvent(
        'SERP',
        'Tour Clicks Performance',
        `Pos=${position},Rec=${countRecommendedTours},List=${count},Pg=${this.currentPage},Exl=${hasExclusiveTag},TP=${hasTppPick},Fc=${hasFreeCancellationTag},Sp=${hasSponsoredTag},Pt=${hastTagPrice},BP=${hasPrice}`,
        {
          sponsoredTourID,
          ampEventName: hasSponsoredTag ? 'sponsored_content_clicked' : undefined,
        },
      );
    });

    $list.on('click', `${SELECTOR_JS_TOUR_CARD} .js-br__button-wrapper-view-cta`, () => sendGoogleEvent('SERP', 'Tour card', 'Primary CTA', { type_from: 'SERP', type_to: 'TDP', ampEventName: 'page_navigation' }));

    $list.on('click', `${SELECTOR_JS_TOUR_CARD} ${SELECTOR_JS_RATING_LINK}`, () => {
      sendGoogleEvent(
        'SERP',
        'Tour card',
        'Reviews',
      );
    });

    $list.on('click', `${SELECTOR_JS_TOUR_CARD} ${SELECTOR_JS_IMAGE_LINK}`, () => sendGoogleEvent('SERP', 'Tour card', 'Click image', { type_from: 'SERP', type_to: 'TDP', ampEventName: 'page_navigation' }));

    $list.on('click', `${SELECTOR_JS_TOUR_CARD} ${SELECTOR_JS_TOUR_NAME}`, () => sendGoogleEvent('SERP', 'Tour card', 'Title', { type_from: 'SERP', type_to: 'TDP', ampEventName: 'page_navigation' }));

    $list.on('click', `${SELECTOR_JS_TOUR_CARD} .theme`, () => {
      sendGoogleEvent(
        'SERP',
        'Tour card',
        'Travel style tag',
      );
    });

    $list.on('click', '.js-aa-exclusive-tag', () => {
      sendGoogleEvent(
        'SERP',
        'Tour card',
        'Exclusive Tag',
      );
    });

    $list.on('click', '.values a', (event) => {
      const $target = $(event.currentTarget);
      const $description = $target.parent();
      const $title = $description.prev();
      let text = $title.text().trim();
      text = text[0].toUpperCase() + text.substring(1);

      sendGoogleEvent(
        'SERP',
        'Tour card',
        `${text} link`,
      );
    });

    const $noDepartureDates = $list.find('.js-br__price-wrapper-no-price');
    if ($noDepartureDates.length) {
      const noPriceIds = [];

      $noDepartureDates.forEach((noPrice) => noPriceIds.push($(noPrice).parents('.tour').data('id')));

      sendGoogleEvent(
        'SERP',
        'No Departure Dates Loaded',
        noPriceIds.join(', '),
        {
          nonInteraction: true,
        },
      );
    }
  };

  const onClickToggleInformation = (event) => {
    const $element = $(event.currentTarget);

    if ($element.hasClass('close')) {
      $element.text($element.data('more-text'));
    } else {
      $element.closest('.tour').find('.show-more').click();

      $element.text($element.data('less-text'));
    }
    $element.toggleClass('close');

    const $tour = $element.parents('.tour');
    $tour.find('blockquote, .values, p[itemprop="description"], .js-br__availability-wrapper, .pdf-cta').toggleClass('active');

    sendGoogleEvent('SERP', $element.hasClass('close') ? 'Tour Detail Show' : 'Tour Detail Hide', $tour.find(SELECTOR_JS_TOUR_NAME).text());
  };

  const onClickShowMoreValues = (event) => {
    const $shipsContainer = $(event.currentTarget).closest('dd');
    $shipsContainer.find('.hid').removeClass('hid');
    $shipsContainer.find('.show-more').remove();

    const valueType = $shipsContainer.length && $shipsContainer.prev().text().trim().toLowerCase();

    if (!valueType) {
      return;
    }

    sendGoogleEvent('SERP', 'More', valueType);
  };

  const onClickShowMoreTags = (event) => {
    const $tagsContainer = $(event.currentTarget).parent();
    $tagsContainer.find('.ao-serp-tour-card__tags-item').removeClass('hid');
    $tagsContainer.find(SELECTOR_TOUR_TAGS_SHOW_MORE).remove();

    sendGoogleEvent('SERP', 'More', 'travel style');
  };

  /* initiate pagination */
  const onClickPagination = () => {
    this.updateTours(true);
    sendGoogleEvent(
      'SERP',
      'Load More',
      'Pagination',
      { ampEventName: 'show_more_adventures_clicked' },
    );
  };

  const handleTitleMouseMove = (event) => {
    const $currentTarget = $(event.currentTarget);
    const offset = $currentTarget.offset();
    const $tooltip = $currentTarget.siblings(SELECTOR_TOOLTIP);
    const x = event.pageX - offset.left;
    const y = event.pageY - offset.top;
    $tooltip.css({
      top: `${y + 5}px`,
      left: `${x + 5}px`,
    });
  };

  const handleTitleMouseEnter = (event) => {
    const $currentTarget = $(event.currentTarget);
    // Only display tooltip if the tour name is truncated
    if ($currentTarget[0].clientHeight === $currentTarget[0].scrollHeight) return;

    const $tooltip = $currentTarget.siblings(SELECTOR_TOOLTIP);
    $tooltip.removeClass('hid');

    $currentTarget.on('mousemove', handleTitleMouseMove);
  };

  const handleTitleMouseLeave = (event) => {
    const $currentTarget = $(event.currentTarget);
    const $tooltip = $currentTarget.siblings(SELECTOR_TOOLTIP);

    $tooltip.addClass('hid');
    $currentTarget.off('mousemove', handleTitleMouseMove);
  };

  const tooltipInteraction = () => {
    const $tourNames = $(SELECTOR_JS_TOUR_NAME);
    $tourNames.on('mouseenter', handleTitleMouseEnter).on('mouseleave', handleTitleMouseLeave);
  };

  const handleSliderPopupClose = (event) => {
    // Only handle on mobile
    if (window.innerWidth > MOBILE_WIDTH) return;

    event.stopPropagation();
    const closeButton = event.currentTarget;
    const sliderPopup = closeButton.closest(SELECTOR_SLIDER_POPUP);
    const slider = closeButton.closest(SELECTOR_SLIDER);
    const tooltipIcon = closeButton.closest(SELECTOR_TOOLTIP_ICON);

    if (sliderPopup) {
      sliderPopup.classList.remove('ao-serp-tour-card__installments--is-visible');
      sliderPopup.classList.add('ao-serp-tour-card__installments--is-hidden');
    }

    if (slider) {
      slider.classList.remove('ao-serp-tour-card__installments--is-visible');
    }

    if (tooltipIcon) {
      tooltipIcon.classList.add('ao-serp-tour-card__installments--is-closed');

      // Remove the closed state after the mouse leaves
      tooltipIcon.addEventListener('mouseleave', () => {
        tooltipIcon.classList.remove('ao-serp-tour-card__installments--is-closed');
      }, { once: true });
    }
  };

  const handleTooltipIconHover = (event) => {
    // Track hover/click interaction for both mobile and desktop
    sendAmplitudeEvent({
      ampEventName: 'serp_affordability_hover_or_click',
    });

    // Only handle slider popup on mobile
    if (window.innerWidth > MOBILE_WIDTH) return;

    const tooltipIcon = event.currentTarget;
    const slider = tooltipIcon.querySelector(SELECTOR_SLIDER);
    const sliderPopup = tooltipIcon.querySelector(SELECTOR_SLIDER_POPUP);

    if (slider) {
      slider.classList.add('ao-serp-tour-card__installments--is-visible');
    }
    if (sliderPopup) {
      sliderPopup.classList.remove('ao-serp-tour-card__installments--is-hidden');
      sliderPopup.classList.add('ao-serp-tour-card__installments--is-visible');
    }
  };

  const initSliderPopupClose = () => {
    // Add hover tracking for all devices
    $(document).on('mouseenter', SELECTOR_TOOLTIP_ICON, handleTooltipIconHover);

    // Only initialize mobile-specific behavior
    if (window.innerWidth <= MOBILE_WIDTH) {
      $(document).on('click', SELECTOR_SLIDER_POPUP_CLOSE, handleSliderPopupClose);
    }

    // Handle resize events to add/remove listeners
    $(window).on('resize', () => {
      const isMobile = window.innerWidth <= MOBILE_WIDTH;

      if (isMobile) {
        $(document).on('click', SELECTOR_SLIDER_POPUP_CLOSE, handleSliderPopupClose);
      } else {
        $(document).off('click', SELECTOR_SLIDER_POPUP_CLOSE, handleSliderPopupClose);

        // Reset any open popups when switching to desktop
        $(SELECTOR_SLIDER_POPUP).removeClass('ao-serp-tour-card__installments--is-visible ao-serp-tour-card__installments--is-hidden');
        $(SELECTOR_SLIDER).removeClass('ao-serp-tour-card__installments--is-visible');
        $(SELECTOR_TOOLTIP_ICON).removeClass('ao-serp-tour-card__installments--is-closed');
      }
    });
  };

  this.setSerpCache = () => {
    if (!getServiceWorkerSupport()) {
      return;
    }

    const activeServiceWorkerPromise = getActiveServiceWorkerFlag();

    activeServiceWorkerPromise.then((hasActiveServiceWorker) => {
      if (hasActiveServiceWorker) {
        byUserInteraction('caching', () => {
          import(/* webpackChunkName: "serpCache" */'@html/serp/cache').then((module) => {
            const SerpCache = module.default;
            if (!serpCache) {
              serpCache = new SerpCache(`${SELECTOR_JS_TOUR_CARD}`, 'img:not(.map)');
            }
            serpCache.initiate();
          });
        });
      }
    });
  };

  this.initiate = () => {
    this.setSerpCache();

    const $contentPageElement = $('.list>ul>li.content-page-element');
    if ($contentPageElement.length > 0 && typeof contentElement === 'undefined') {
      contentElement = {
        html: $contentPageElement.clone(),
        position: $contentPageElement.index(),
      };
    } else {
      contentElement = false;
    }

    $('body').on('click', LOAD_MORE, onClickPagination);

    serpBrochure.initiate();

    serpTourTags.initiate();

    wishlist.initiate();

    // Initialize slider popup close functionality
    initSliderPopupClose();

    /* operator list - theme mouseover */
    $('.oper .bt .l li').mouseover((event) => {
      const $element = $(event.currentTarget);
      $element.find('a').css('background', `#${$element.attr('data-color')}`);
    }).mouseout((event) => {
      $(event.currentTarget).find('a').css('background', '#ccc');
    });

    byUserInteraction('serp-tooltips', () => {
      /* operator list - pictogram mouseover (tooltip) */
      libInit('tooltip');

      if (getPageType() !== 'g') {
        tooltipOperatorRating();
        initiateTooltips();
      }
    });

    initiateGoogleEvents();

    $('body').on(
      'click',
      '.list .bl .map, table tbody tr .ln a, .js-bl__map-button',
      (event) => {
        event.preventDefault();
        import(/* webpackChunkName: "serpToursMap" */'@html/serp/tours/map').then((module) => {
          const SerpToursMap = module.default;
          if (!serpMap) serpMap = new SerpToursMap(SELECTOR_JS_TOUR_CARD);
          serpMap.initiate(event);
        });
      },
    );

    $('.list')
      .on('click', `${SELECTOR_JS_TOUR_CARD} .show`, onClickToggleInformation)
      .on('click', 'li .show-more', onClickShowMoreValues)
      .on('click', `${SELECTOR_JS_TOUR_CARD} ${SELECTOR_TOUR_TAGS_SHOW_MORE}`, onClickShowMoreTags)
      // Open tours in new tab only on mobile
      // for SEO reasons we have to keep the markup the same on mobile and desktop
      .on('click', 'a.blank', (event) => {
        const $element = $(event.target);
        const $link = $(event.currentTarget);
        if (!$element.hasClass('map') && !$element.hasClass('sbtn') && !$element.hasClass('js-bl__map-button') && !$element.hasClass('js-bl__map-button--view')) {
          if ($(window).width() > TABLET_WIDTH) {
            window.open($link.attr('href'), '_blank');
          } else {
            window.location = $link.attr('href');
          }
          return false;
        }

        return true;
      });

    regenerateLinks();

    initTrackTourViews();

    highlightTags.initiate();
    tooltipInteraction();
    if ($('.ao-header-pax-selector').length) {
      updateTourResultsHeading();
    }
  };
}
